'use client';
import { classNames } from '@repo/ui/src/utils/classNames';
import CheckIcon from '@repo/ui/src/components/Icons/CheckIcon';
import BaseAccordion from '../../components/BaseAccordion';
import Button from '@repo/ui/src/components/Button';

const FilterAccordion = ({ currentFilters, setFilters, filter }) => {
  const { options, filterType, title } = filter || {};
  return (
    <BaseAccordion
      title={title}
      titleVariant="h3"
      titleClassName="tra-text-web-sub-3"
      className="[&_before]:!tw-bg-white"
    >
      <ul className="tw-list-none tw-p-0">
        {options?.map((series, index) => {
          const isActive =
            currentFilters &&
            currentFilters[filterType] &&
            currentFilters[filterType].includes(series.filter);
          return (
            <li className="tw-mb-2" key={series.title}>
              <Button
                className={classNames(isActive && 'tw-font-bold tw-py-0')}
                onClick={(e) => {
                  e.preventDefault();
                  setFilters({ filterName: series.filter, filterType });
                }}
                variant="bare"
                size="small"
                aria-current={isActive ? 'true' : 'false'}
              >
                <CheckIcon
                  color='currentColor'
                  decorative
                  title={`Check-${series.title}-${index}`}
                  className={classNames(
                    "tw-mr-1",
                    isActive ? 'tw-opacity-100' : 'tw-opacity-0',
                  )}
                />
                {series.title}
              </Button>
            </li>
          );
        })}
      </ul>
    </BaseAccordion>
  );
};

export default FilterAccordion;
